/** 名称后面跟次要的 #id；名称没解析到时 nameOf 已经返回 "#id"，只显示一次，不重复成 "#3 #3"。 */
export function NameId({ name, id }: { name: string; id: number }) {
  if (name === `#${id}`) return <>{name}</>;
  return <>{name} <span className="ax-secondary">#{id}</span></>;
}
